module.exports = __webpack_public_path__ + "assets/img/title.577128b4.png";